import { MappingTypes } from './types';

export const mappingDataSuccess = (payload: any) => {
  return {
    type: MappingTypes.MAPPING_DATA_SUCCESS,
    payload,
  };
};

export const mappingFailure = () => {
  return {
    type: MappingTypes.MAPPING_DATA_FAILURE,
  };
};
